<template>
  <div class="m-index-ordos">
    <!-- 顶部栏：logo + 登录 -->
    <div class="ordos-m-header">
      <img
        class="ordos-m-header__bar"
        src="@/assets/ordos/m/header-bar.png"
        alt="鄂尔多斯暖城工匠线上学习平台"
      />
      <div class="ordos-m-header__nav">
        <img
          v-if="userInfo"
          class="ordos-m-header__avatar"
          :src="userInfo.avatar || require('@/assets/head-default-personal.png')"
          @click="$router.push('/userCenter')"
        />
        <span v-else class="ordos-m-header__login" @click="ShowMLoginModal">登录</span>
      </div>
    </div>

    <!-- 首屏视频 -->
    <div class="ordos-m-hero">
      <video
        ref="heroVideo"
        class="ordos-m-hero__video"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline="true"
        x5-playsinline="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="false"
        preload="auto"
        :src="heroVideoUrl"
        @loadeddata="playHeroVideo"
        @canplay="playHeroVideo"
      ></video>
    </div>

    <div class="ordos-m-content">
      <!-- 金刚区菜单 -->
      <div class="ordos-m-menu" v-if="menuList && menuList.length">
        <div
          v-for="menu in menuList.slice(0, 5)"
          :key="menu.name"
          class="ordos-m-menu__item"
          @click="menuIconClick(menu)"
        >
          <img :src="menu.icon" class="ordos-m-menu__icon" alt="" />
          <p class="ordos-m-menu__title">{{ menu.name }}</p>
        </div>
      </div>

      <!-- Banner 轮播 -->
      <swiper
        class="ordos-m-banner"
        ref="bannerSwiper"
        :options="swiperOptionsBanner"
        v-if="bannerList.length"
      >
        <swiper-slide
          v-for="(item, index) in bannerList"
          :key="item.image + '_' + index"
        >
          <img v-if="!item.link" class="ordos-m-banner__img" :src="item.image" />
          <a :href="item.link" v-else>
            <img class="ordos-m-banner__img" :src="item.image" />
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <!-- 主体内容 -->
      <div class="ordos-m-body">
        <div class="ordos-m-load" v-if="loadingState">
          <div class="ordos-m-load__title"></div>
          <div class="ordos-m-load__tabs">
            <span></span>
            <span></span>
          </div>
          <div class="ordos-m-load__grid">
            <p></p>
            <p></p>
            <p></p>
            <p></p>
          </div>
        </div>

        <div
          v-for="group in ordosModuleGroups"
          :key="group.key"
          :id="'ordos-module-' + group.key"
          class="ordos-m-module"
        >
          <div class="ordos-m-module__head">
            <p class="ordos-m-module__title">- {{ group.powerName }} -</p>
            <p class="ordos-m-module__sub" v-if="group.subTitle">{{ group.subTitle }}</p>
          </div>

          <div class="ordos-m-module__tabs">
            <span
              v-if="group.basic"
              class="ordos-m-tab"
              :class="{ 'ordos-m-tab--active': getOrdosTab(group.key) === 'basic' }"
              @click="setOrdosTab(group.key, 'basic')"
            >基础课程</span>
            <span
              v-if="group.advanced"
              class="ordos-m-tab"
              :class="{ 'ordos-m-tab--active': getOrdosTab(group.key) === 'advanced' }"
              @click="setOrdosTab(group.key, 'advanced')"
            >进阶课程</span>
          </div>

          <transition name="ordos-m-switch" mode="out-in">
            <ul
              v-if="getActiveModule(group)"
              :key="group.key + '-' + getOrdosTab(group.key)"
              class="ordos-m-course-list"
            >
              <li
                v-for="subItem in getActiveModule(group).list.slice(0, 4)"
                :key="subItem.id"
                class="ordos-m-course-item"
              >
                <router-link :to="'/recordedInfo/' + subItem.data_id">
                  <div class="ordos-m-course-item__img">
                    <img v-lazy="subItem.image" :key="subItem.image" alt="" />
                  </div>
                  <div class="ordos-m-course-item__title">
                    <p>{{ subItem.name }}</p>
                  </div>
                </router-link>
              </li>
            </ul>
          </transition>

          <div
            class="ordos-m-module__more"
            v-if="getActiveModule(group)"
            @click="goOrdosMore(group)"
          >查看更多 &gt;</div>
        </div>
      </div>
    </div>
    <!-- 页脚 -->
    <div class="ordos-m-footer">
      <p>Copyright◎ 2015-2026 kjcxchina.com All Rights Reserved｜京ICP备16012224号 技术支持：中工科创</p>
    </div>

    <div class="loading" v-if="loadingState">
      <div class="loadEffect">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <!-- 全国工匠学院作业提示弹框 -->
    <div v-if="taskHintDialog" class="taskHint-dialog">
      <div class="taskHint-content">
        <i class="el-icon-close close" @click="taskHintDialog = false"></i>
        <div class="taskHint-img">
          <img src="@/assets/m/lmxy_icon_m.png" alt="">
        </div>
        <div class="taskHint-text">
          <p class="title">作业提示</p>
          <p class="text">完成全部课程学习后，需要点击按钮"填写学习心得"进行填写或上传，截止日期为11月7日24时。</p>
          <a class="but" href="https://qggjxy.org.cn/userCenter" target="_self">填写学习心得</a>
        </div>
      </div>
    </div>
    <div v-if="taskHintDialog" class="maskSight-box"></div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { getRequestHost } from "@/utils/axios";

export default {
  name: "IndexOrdos",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      menuList: [],
      menuAllList: [],
      bannerList: [],
      modulelist: [],
      loadingState: true,
      websiteData: "",
      siteInfo: {},
      taskHintDialog: false,
      heroVideoUrl: "https://video.kjcxchina.com/sv/1783c028-19ed8f1508d/1783c028-19ed8f1508d.mp4",
      ordosModuleMeta: [
        { en: "LEADERSHIP", power: "引领力" },
        { en: "ACHIEVEMENT POWER", power: "成就力" },
        { en: "CREATIVITY", power: "创新力" },
        { en: "CONCENTRATION", power: "专注力" },
        { en: "HERITAGE POWER", power: "传承力" },
      ],
      ordosModuleTab: {},
      swiperOptionsBanner: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    ordosModuleGroups() {
      const map = {};
      const order = ["引领力", "成就力", "创新力", "专注力", "传承力"];

      this.modulelist.forEach((item) => {
        if (!item.list || !item.list.length) return;
        if (![1, 2, 3].includes(item.style_id)) return;

        const isBasic = /（基础）|\(基础\)/.test(item.name);
        const isAdvanced = /（进阶）|\(进阶\)/.test(item.name);
        const baseName = item.name.replace(/（基础）|（进阶）|\(基础\)|\(进阶\)/g, "");
        const colonIdx = baseName.indexOf("：");
        const powerName = colonIdx > -1 ? baseName.slice(0, colonIdx) : baseName;
        const subTitle = colonIdx > -1 ? baseName.slice(colonIdx + 1) : "";
        const meta = this.ordosModuleMeta.find((m) => m.power === powerName) || { en: "" };

        if (!map[powerName]) {
          map[powerName] = {
            key: powerName,
            powerName,
            subTitle,
            en: meta.en,
            basic: null,
            advanced: null,
          };
        }

        if (isBasic) map[powerName].basic = item;
        else if (isAdvanced) map[powerName].advanced = item;
        else if (!map[powerName].basic) map[powerName].basic = item;
        else map[powerName].advanced = item;
      });

      return order
        .filter((key) => map[key] && (map[key].basic || map[key].advanced))
        .map((key) => map[key]);
    },
  },
  mounted() {
    this.GetUserInfo();
    this.getWebsiteInfo();
    this.getNeedLogin();
    this.getBenner();
    this.getModule();
    this.websiteData = this.$store.state.websiteState;

    if (this.$route.query.noncestr) {
      this.weLoin(this.$route.query.noncestr);
    }

    this.$nextTick(() => {
      this.initHeroVideo();
    });
  },
  beforeDestroy() {
    this.destroyHeroVideo();
  },
  methods: {
    ...mapMutations(["ShowMLoginModal", "ShowTipModal", "CloseTipModal", "GetUserInfo"]),
    playHeroVideo() {
      const video = this.$refs.heroVideo;
      if (!video) return;
      video.muted = true;
      video.setAttribute("muted", "muted");
      const playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {});
      }
    },
    initHeroVideo() {
      const video = this.$refs.heroVideo;
      if (!video) return;

      const tryPlay = () => this.playHeroVideo();

      // 微信内置浏览器：需在 WeixinJSBridge 就绪后触发 play
      if (typeof window.WeixinJSBridge === "object" && window.WeixinJSBridge.invoke) {
        window.WeixinJSBridge.invoke("getNetworkType", {}, tryPlay);
      } else {
        this._weixinBridgeReadyHandler = tryPlay;
        document.addEventListener("WeixinJSBridgeReady", this._weixinBridgeReadyHandler, false);
      }

      // 飞书 / 微信等 WebView：首次触摸时兜底播放
      this._heroVideoTouchHandler = () => tryPlay();
      document.addEventListener("touchstart", this._heroVideoTouchHandler, { once: true, passive: true });
      document.addEventListener("click", this._heroVideoTouchHandler, { once: true });

      tryPlay();
    },
    destroyHeroVideo() {
      if (this._weixinBridgeReadyHandler) {
        document.removeEventListener("WeixinJSBridgeReady", this._weixinBridgeReadyHandler);
      }
      if (this._heroVideoTouchHandler) {
        document.removeEventListener("touchstart", this._heroVideoTouchHandler);
        document.removeEventListener("click", this._heroVideoTouchHandler);
      }
    },
    getOrdosTab(groupKey) {
      if (this.ordosModuleTab[groupKey]) {
        return this.ordosModuleTab[groupKey];
      }
      const group = this.ordosModuleGroups.find((g) => g.key === groupKey);
      if (group && group.basic) return "basic";
      return "advanced";
    },
    setOrdosTab(groupKey, tab) {
      this.$set(this.ordosModuleTab, groupKey, tab);
    },
    getActiveModule(group) {
      const tab = this.getOrdosTab(group.key);
      if (tab === "advanced" && group.advanced) return group.advanced;
      if (group.basic) return group.basic;
      return group.advanced;
    },
    goOrdosMore(group) {
      const module = this.getActiveModule(group);
      if (!module) return;
      this.$router.push("/courseShowList?id=" + module.id);
    },
    normalizeOrdosPowerName(name) {
      const text = String(name || "")
        .replace(/（基础）|（进阶）|\(基础\)|\(进阶\)/g, "")
        .trim();
      const powers = ["引领力", "成就力", "创新力", "专注力", "传承力"];
      const hit = powers.find((item) => text.indexOf(item) > -1);
      if (hit) return hit;
      const colonIdx = text.indexOf("：");
      if (colonIdx > -1) return text.slice(0, colonIdx);
      return text;
    },
    scrollToOrdosModule(name) {
      const powerName = this.normalizeOrdosPowerName(name);
      this.$nextTick(() => {
        const el = document.getElementById("ordos-module-" + powerName);
        if (!el) return;
        const headerOffset = 88;
        const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top, behavior: "smooth" });
      });
    },
    menuIconClick(menu) {
      const power = this.normalizeOrdosPowerName(menu.name);
      const powers = ["引领力", "成就力", "创新力", "专注力", "传承力"];
      if (powers.includes(power)) {
        this.scrollToOrdosModule(power);
        return;
      }
      if (menu.url) {
        if (menu.url.includes("http")) {
          window.location.href = menu.url;
        } else {
          this.$router.push(menu.url);
        }
      }
    },
    getWebsiteInfo() {
      this.$axios.post(`/v1/websiteInfo`, { is_pc: 2 }).then((res) => {
        this.siteInfo = res.data.site_info;
        if (res.data.site_info.id == 108) {
          if (Number(this.$route.query.studyProgress) >= 100) {
            if (!localStorage.getItem("taskHintDialog")) {
              this.taskHintDialog = true;
              localStorage.setItem("taskHintDialog", "true");
            }
          }
        }
        localStorage.setItem("siteInfo", JSON.stringify(res.data.site_info));
        localStorage.setItem("navigation", JSON.stringify(res.data.navigation));
        this.menuList = res.data.navigation;
        if (document.getElementById("titleName")) {
          document.getElementById("titleName").innerText = res.data.site_info.name;
        }
      });
    },
    getNeedLogin() {
      if (localStorage.getItem("needLogin")) {
        this.ShowMLoginModal();
        localStorage.removeItem("needLogin");
      }
    },
    getBenner() {
      this.$axios.post(`/v1/home/banner`, { type: "2" }).then((res) => {
        if (res.data.length == 1) {
          this.swiperOptionsBanner.loop = false;
        }
        this.bannerList = res.data;
      });
    },
    getModule() {
      this.$axios.post(`/v1/home/module`).then((res) => {
        if (res.data.length > 0) {
          this.getModuleData(res.data);
        } else {
          this.loadingState = false;
        }
      });
      this.$axios.post(`/v1/home/category`).then((res) => {
        if (res.code == 0) {
          this.menuAllList = res.data;
        }
      });
      this.$axios.post(`/v1/home/getStatus`, { host: getRequestHost() }).then((res) => {
        if (res.code == 0) {
          this.websiteData = res.data;
        }
      });
    },
    async getModuleData(moduleData) {
      this.modulelist = moduleData;

      for (let i = 0; i < moduleData.length; i++) {
        let res = await this.$axios.post(`/v1/home/moduleData`, {
          id: moduleData[i].id,
        });

        for (let j = 0; j < this.modulelist.length; j++) {
          if (res.data.total) {
            for (let o = 0; o < res.data.data.length; o++) {
              if (res.data.data[o].module_id == this.modulelist[j].id) {
                if (this.modulelist[j].list) {
                  this.$set(this.modulelist[j].list, o, res.data.data[o]);
                } else {
                  this.$set(this.modulelist[j], "list", []);
                  this.$set(this.modulelist[j].list, o, res.data.data[o]);
                }
              }
            }
          } else {
            for (let o = 0; o < res.data.length; o++) {
              if (res.data[o].module_id == this.modulelist[j].id) {
                if (this.modulelist[j].list) {
                  this.$set(this.modulelist[j].list, o, res.data[o]);
                } else {
                  this.$set(this.modulelist[j], "list", []);
                  this.$set(this.modulelist[j].list, o, res.data[o]);
                }
              }
            }
          }
        }
        this.loadingState = false;
      }
    },
    async weLoin(code) {
      await this.$axios
        .post(`/v1/px/login/getUserinfo`, { noncestr: code })
        .then((res) => {
          if (res.code == 0) {
            this.ShowTipModal({
              text: res.msg,
              ico: "success",
            });
            localStorage.setItem("auth", JSON.stringify(res.data.auth));
            localStorage.setItem("user", JSON.stringify(res.data.user));
            localStorage.setItem("userInfo", JSON.stringify(res.data.user));
            localStorage.setItem("logoDate", Date.parse(new Date()) / 1000);
            this.GetUserInfo();
          } else {
            this.ShowTipModal({
              text: res.msg,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.m-index-ordos {
  min-height: 100vh;
  background: #fff;
  color: #333;
  overflow-x: hidden;
}

/* ===== 顶部栏 ===== */
.ordos-m-header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 88px;
  padding: 0 28px;
  background: #fff;

  &__bar {
    height: 50px;
    width: auto;
    max-width: 520px;
    object-fit: contain;
  }

  &__nav {
    flex-shrink: 0;
  }

  &__login {
    display: block;
    font-size: 24px;
    font-weight: 600;
    color: #262626;
    line-height: 34px;
  }

  &__avatar {
    width: 54px;
    height: 54px;
    border-radius: 50%;
  }
}

/* ===== 首屏视频 ===== */
.ordos-m-hero {
  width: 100%;
  height: 422px;
  overflow: hidden;
  background: #000;

  &__video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    display: block;
  }
}
.ordos-m-content {
  background-image: url("~@/assets/ordos/m/bg-m.png");
  background-repeat: no-repeat;
  background-size: 100% 100% ;
  background-position: 100% 100% ;
}
/* ===== 金刚区 ===== */
.ordos-m-menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 56px 34px 56px;
  // background: #fff;

  &__item {
    width: 20%;
    text-align: center;
    margin-bottom: 0;
  }

  &__icon {
    width: 96px;
    height: 96px;
    display: block;
    margin: 0 auto;
  }

  &__title {
    margin: 10px 0 0;
    font-weight: 500;
    font-size: 24px;
    color: #333333;
    line-height: 34px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* ===== Banner ===== */
.ordos-m-banner {
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding: 2px 32px 0;
  margin-bottom: 64px;
  &__img {
    width: 100%;
    height: 400px;
    display: block;
    object-fit: cover;
    border-radius: 10px;
    box-shadow: 0 16px 28px rgba(188, 0, 0, 0.14);
  }

  ::v-deep .swiper-pagination-bullet {
    width: 16px;
    height: 6px;
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.5);
    opacity: 1;
  }

  ::v-deep .swiper-pagination-bullet-active {
    width: 32px;
    background: #fff;
  }
}

/* ===== 主体内容区 ===== */
.ordos-m-body {
  padding: 34px 32px 46px;
}

/* ===== 骨架屏 ===== */
.ordos-m-load {
  margin-bottom: 48px;

  &__title {
    width: 260px;
    height: 40px;
    margin: 0 auto 24px;
    border-radius: 6px;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.06));
    background-size: 200% 100%;
    animation: ordosSkeleton 1.4s ease-in-out infinite;
  }

  &__tabs {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;

    span {
      flex: 1;
      height: 64px;
      border-radius: 32px;
      background: linear-gradient(90deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.05));
      background-size: 200% 100%;
      animation: ordosSkeleton 1.4s ease-in-out infinite;
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;

    p {
      height: 280px;
      border-radius: 8px;
      margin: 0;
      background: linear-gradient(90deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.05));
      background-size: 200% 100%;
      animation: ordosSkeleton 1.4s ease-in-out infinite;
    }
  }
}

@keyframes ordosSkeleton {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ===== 模块 ===== */
.ordos-m-module {
  margin-bottom: 64px;

  &__head {
    text-align: center;
    margin-bottom: 64px;
  }

  &__title {
    font-weight: bold;
    font-size: 36px;
    color: #9E0506;
    line-height: 44px;
    margin: 0;
    margin-bottom: 12px;
  }

  &__sub {
    font-weight: bold;
    font-size: 28px;
    color: #DAB46F;
    line-height: 34px;
    margin: 2px 0 0;
  }

  &__tabs {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-bottom: 40px;
  }

  &__more {
    display: block;
    width: 168px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    font-weight: 400;
    font-size: 24px;
    color: #9E0506;
    background: #ffe5e5;
    border-radius: 8px;
    margin: 52px auto 0;
  }
}

/* ===== Tab 切换 ===== */
.ordos-m-tab {
  flex: 0 0 180px;
  height: 72px;
  line-height: 72px;
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  color: #c12020;
  background: #ffe8e8;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  transition: color 0.3s ease, background-color 0.3s ease;

  &--active {
    color: #fff;
    background: url("~@/assets/ordos/m/tab-active.png") no-repeat center center;
    background-size: 100% 100%;
  }
}

/* ===== 课程 2x2 网格 ===== */
.ordos-m-course-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 26px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.ordos-m-course-item {
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(70, 20, 20, 0.08);

  a {
    text-decoration: none;
    display: block;
  }

  &__img {
    width: 100%;
    height: 168px;
    overflow: hidden;
    background: #f0f0f0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  &__title {
    padding: 12px 14px 14px;

    p {
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 34px;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      min-height: 62px;
    }
  }
}

/* ===== Tab 切换动画 ===== */
.ordos-m-switch-enter-active,
.ordos-m-switch-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.ordos-m-switch-enter,
.ordos-m-switch-leave-to {
  opacity: 0;
  transform: translateY(12px);
}

/* ===== 页脚 ===== */
.ordos-m-footer {
  background: #e9ecef;
  text-align: center;
  padding: 32px;

  p {
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    line-height: 36px;
    margin: 0;
  }
}

/* ===== 加载动画 ===== */
.loading {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loadEffect {
  width: 100px;
  height: 100px;
  position: relative;
}

.loadEffect span {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #9e0506;
  position: absolute;
  animation: load 1.04s ease infinite;
}

@keyframes load {
  0% { opacity: 1; }
  100% { opacity: 0.2; }
}

.loadEffect span:nth-child(1) { left: 0; top: 50%; margin-top: -8px; animation-delay: 0.13s; }
.loadEffect span:nth-child(2) { left: 10px; top: 10px; animation-delay: 0.26s; }
.loadEffect span:nth-child(3) { left: 50%; top: 0; margin-left: -8px; animation-delay: 0.39s; }
.loadEffect span:nth-child(4) { top: 10px; right: 10px; animation-delay: 0.52s; }
.loadEffect span:nth-child(5) { right: 0; top: 50%; margin-top: -8px; animation-delay: 0.65s; }
.loadEffect span:nth-child(6) { right: 10px; bottom: 10px; animation-delay: 0.78s; }
.loadEffect span:nth-child(7) { bottom: 0; left: 50%; margin-left: -8px; animation-delay: 0.91s; }
.loadEffect span:nth-child(8) { bottom: 10px; left: 10px; animation-delay: 1.04s; }

/* ===== 作业提示弹框 ===== */
.taskHint-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10001;
  width: 600px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;

  .close {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 36px;
    color: #999;
    cursor: pointer;
    z-index: 1;
  }

  .taskHint-img img {
    width: 100%;
    display: block;
  }

  .taskHint-text {
    padding: 30px 40px 40px;

    .title {
      font-size: 36px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 20px;
    }

    .text {
      font-size: 28px;
      color: #666;
      line-height: 40px;
      margin-bottom: 30px;
    }

    .but {
      display: block;
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      background: #9e0506;
      color: #fff;
      font-size: 30px;
      border-radius: 8px;
      text-decoration: none;
    }
  }
}

.maskSight-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
</style>
